import React from "react";
import TextField from "@mui/material/TextField";
import withAutoFill from "./withAutoFill";
import InputAdornment from "@mui/material/InputAdornment";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  root: {
    "& .MuiInputBase-input": {
      padding: "6px 10px 7px",
      height: "1.1876em",
    },
    "& .MuiInputLabel-root": {
      color: "rgba(0, 0, 0, 0.54)",
      // padding: 0,
      fontSize: "0.8571428571428571rem",
      fontFamily: "Roboto",
      fontWeight: 400,
      lineHeight: 1,
      // transform: 'translate(0, 24px) scale(1)',
      // letterSpacing: 0,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#004C6A",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "#004C6A",
    },
  },
  sidebarRoot: {
    "& .MuiInputBase-root": {
      border: "1px solid #6D6D6D !important",
      borderRadius: "0",
      padding: "5px 10px",
      fontSize: "16px",
      "&:before, &:after": {
        display: "none !important",
      },
      "&:hover": {
        borderColor: "#333 !important",
        "&:before, &:after": {
          display: "none !important",
        },
      },
      "&.Mui-focused": {
        borderColor: "#6D6D6D !important",
        borderWidth: "1px !important",
        "&:before, &:after": {
          display: "none !important",
        },
      },
    },
    "& .MuiInputBase-input": {
      padding: "0",
    },
    "& .MuiInputLabel-root": {
      display: "none",
    },
  },
}));

const helperUseStyles = makeStyles(() => ({
  helperText: {
    lineHeight: 1.1,
    letterSpacing: 0,
  },
}));

const Text = (props) => {
  let { input, inputId, handleInputs, value, sidebarMode } = props;
  const classes = useStyles();
  const helperClasses = helperUseStyles();

  let inputValue = value;
  if (input.hasOwnProperty('relativeInputsValueAccessor') && input.hasOwnProperty('relativeInputsData')) {
    inputValue = input.relativeInputsValueAccessor(input.relativeInputsData)
    input.value = inputValue;
  }
  if (value === null) {
    inputValue = '';
  }

  let required = input.hasOwnProperty("yup");

  if (input.hasOwnProperty("requiredAccessor") && input.hasOwnProperty("relativeInputsData")) {
    required = input.requiredAccessor(input.relativeInputsData);
  } else if (input.hasOwnProperty("required")) {
    required = input.required;
  }

  const InputProps = {};

  if (input.icon) {
    InputProps.startAdornment = (
      <InputAdornment position="start">{input.icon}</InputAdornment>
    );
  }

  if (input.endIcon) {
    InputProps.endAdornment = (
      <InputAdornment position="end">{input.endIcon}</InputAdornment>
    );
  }

  return (
    <TextField
      variant="standard"
      className={sidebarMode ? classes.sidebarRoot : classes.root}
      error={input.error}
      key={inputId}
      name={inputId}
      disabled={input?.disabled}
      value={inputValue}
      required={required}
      autoFocus={input.autoFocus}
      label={input.label}
      autoComplete={input.autoComplete}
      onChange={handleInputs}
      onBlur={props.handleBlur}
      helperText={input.error && input.errorMessage}
      inputProps={{
        required: false,
        size: Math.max(
          (inputValue ? String(inputValue).length : 0),
          input.label ? input.label.length : 10,
          10
        ),
        onFocus: (event) => {
          if (input.selectOnFocus) {
            event.target.select();
          }
        },
      }}
      InputProps={InputProps}
      FormHelperTextProps={{
        className: helperClasses.helperText,
      }}
      sx={input.sx || input.styles}
    />
  );
};

export default withAutoFill(Text);
